module.exports = {"230207001":"东安街道","230207002":"富强街道","230207003":"跃进街道","230207004":"繁荣街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230207.json
// module id = 638
// module chunks = 0